import React, { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { ACTIVE_TOGGLES_QUERY_KEY, parseActiveTogglesParam } from "../shared/utils/active-toggles.utils";

const ActiveTogglesUrlContext = createContext<string[]>([]);

interface ActiveTogglesProviderProps {
    children: React.ReactNode;
}

export function ActiveTogglesProvider({ children }: ActiveTogglesProviderProps): JSX.Element {
    const location = useLocation();
    const search = location.search ?? "";
    const rawActiveToggles = useMemo(
        () => new URLSearchParams(search).get(ACTIVE_TOGGLES_QUERY_KEY),
        [search],
    );
    const value = useMemo(() => parseActiveTogglesParam(rawActiveToggles), [rawActiveToggles]);

    return (
        <ActiveTogglesUrlContext.Provider value={value}>
            {children}
        </ActiveTogglesUrlContext.Provider>
    );
}

export function useActiveTogglesFromUrl(): string[] {
    return useContext(ActiveTogglesUrlContext);
}
